import React from 'react';
import { MoreIcon } from '@mentimeter/ragnar-visuals';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import {
  DropdownMenuContainer,
  DropdownMenuRoot,
  DropdownMenuTrigger,
} from '@mentimeter/ragnar-ui/menu';
import { Text } from '@mentimeter/ragnar-ui/text';
import { useTranslations } from 'next-intl';

interface GroupModerationMenuProps {
  onDismiss: () => void;
  isShowing: boolean;
}

export const GroupModerationOnboarding = ({
  isShowing,
  onDismiss,
}: GroupModerationMenuProps) => {
  const translate = useTranslations('presenting.legacy');

  return (
    <DropdownMenuRoot open={isShowing} onOpenChange={onDismiss}>
      <DropdownMenuTrigger>
        <Clickable p={1}>
          <MoreIcon size={2} color="text" />
        </Clickable>
      </DropdownMenuTrigger>
      <DropdownMenuContainer align="start" p="space6" maxWidth="252px">
        <Text fontSize="125" fontWeight="semiBold" color="text">
          {translate('open.group_moderation.onboarding_title')}
        </Text>
        <Text color="text" mb="space4">
          {translate('open.group_moderation.onboarding_description')}
        </Text>
        <Clickable onClick={onDismiss} alignSelf="flex-end">
          <Text fontSize="125" color="primary" fontWeight="semiBold">
            {translate('open.group_moderation.onboarding_dismiss')}
          </Text>
        </Clickable>
      </DropdownMenuContainer>
    </DropdownMenuRoot>
  );
};
